export default "/images/vendor/flag-icons/flags/4x3/ps.svg?b57e63208c02645d8f1e9dfa6f44935e";